import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";
import Switch from "react-switch";
import { MdDelete } from 'react-icons/md';

//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const TableFloor = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {

    //tables
    floorList,
    setFloorList,
    setPaginatedFloor,
    setFloorforSearch,
    floorForSearch,

    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
  //new group
  let [newTableFloor, setnewTableFloor] = useState({
    name: "",
    code: "",
    status:true,
    edit: false,
    editSlug: null,
    uploading:false
  });


  //search result
  let [searchedFloor, setSearchedFloor] = useState({
    list: null,
    searched: false,
  });

  //is stutus
  const handleStatus = (e) => {
    setnewTableFloor({
      ...newTableFloor,
      status: !newTableFloor.status
    })
  }

  //set name, capacity hook
  const handlesetnewTableFloor = (e) => {
    setnewTableFloor({ ...newTableFloor, [e.target.name]: e.target.value });
  }; 

  //Save New table
  const handleSavenewTableFloor = (e) => {
    e.preventDefault();
    if (newTableFloor.name !== null) {
      setnewTableFloor({
        ...newTableFloor,
        uploading: true,
      });
      const branchUrl = BASE_URL + `/settings/new-floor`;
      let formData = new FormData();
      formData.append("name", newTableFloor.name);
      formData.append("short_code", newTableFloor.code);
      formData.append("status", newTableFloor.status);
      return axios
        .post(branchUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setnewTableFloor({
            name: "",
            code: "",
            status:true,
            edit: false,
            editSlug: null,
            uploading: false,
          });
          setFloorList(res.data[0]);
          setFloorforSearch(res.data[1]);
          setSearchedFloor({
            ...searchedFloor,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Floor has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          document.getElementById('close-btn').click();
        })
        .catch((error) => {
          setLoading(false);
          setnewTableFloor({
            ...newTableFloor,
            uploading: false,
          });
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    } else {
      toast.error(`${_t(t("Please add floor"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //set edit true & values
  const handleSetEdit = (slug) => {
    let table = floorList.data.find((item) => {
      return item.slug === slug;
    });
    setnewTableFloor({
      ...newTableFloor,
      name: table.name,
      code: table?.code ?? "",
      status: table.status === "1" ? true : false,
      editSlug: table.slug,
      edit: true,
    });
  };

  //update table
  const handleUpdateTableFloor = (e) => {
    e.preventDefault();
    setnewTableFloor({
      ...newTableFloor,
      uploading: true,
    });
    const branchUrl = BASE_URL + `/settings/update-floor`;
    let formData = new FormData();
    formData.append("name", newTableFloor.name);
    formData.append("short_code", newTableFloor.code);
    formData.append("status", newTableFloor.status);
    formData.append("editSlug", newTableFloor.editSlug);
    return axios
      .post(branchUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setnewTableFloor({
          name: "",
          code: "",
          status:true,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setFloorList(res.data[0]);
        setFloorforSearch(res.data[1]);
        setSearchedFloor({
          ...searchedFloor,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Floor has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch(() => {
        setLoading(false);
        setnewTableFloor({
          ...newTableFloor,
          uploading: false,
        });
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //search table here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedFloor({ ...searchedFloor, searched: false });
    } else {
      let searchedList = floorForSearch.filter((item) => {
        let lowerCaseItemName = item.name.toLowerCase();
        return (
          lowerCaseItemName.includes(searchInput)
        );
      });
      setSearchedFloor({
        ...searchedFloor,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of table
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteFloor(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete table here
  const handleDeleteFloor = (slug) => {
    const branchUrl = BASE_URL + `/settings/delete-floor/${slug}`;
    return axios
      .get(branchUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFloorList(res.data[0]);
        setFloorforSearch(res.data[1]);
        setSearchedFloor({
          ...searchedFloor,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Floor has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Floor"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addTable" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newTableFloor.edit
                    ? _t(t("Add new floor"))
                    : _t(t("Update floor"))}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                id="close-btn"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newTableFloor.uploading === false ? (
                <div key="fragment-table-1">
                  <form
                    onSubmit={
                      !newTableFloor.edit ? handleSavenewTableFloor : handleUpdateTableFloor
                    }
                    autoComplete="off"
                  >
                    <div className="row">
                      <div className="col-8">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Floor Name"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="e.g. Table 01"
                          value={newTableFloor.name || ""}
                          required
                          onChange={handlesetnewTableFloor}
                        />
                      </div>
                      <div className="col-4">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Short Code"))}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="code"
                          name="code"
                          value={newTableFloor.code || ""}
                          onChange={handlesetnewTableFloor}
                        />
                      </div>
                    </div>
                    <div className="mt-3 d-flex align-items-center">
                    <Switch
                      checked={newTableFloor.status}
                      name="status"
                      onChange={(e) => {
                          handleStatus(e);
                      }}
                      height={22}
                      width={44}
                      offColor="#ee5253"
                      className="float-left"
                    />
                    <label
                      className="form-check-label pointer-cursor ml-2"
                      htmlFor="status"
                    >
                      {_t(t("Status"))}
                    </label>
                    </div> 
                 
                    <div className="mt-4">
                      <div className="row">
                        <div className="col-6">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                          >
                            {!newTableFloor.edit ? _t(t("Save")) : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newTableFloor.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newTableFloor.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading || dataPaginating}/>
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!searchedFloor.searched
                                  ? _t(t("Floor List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center">
                            {/* Search group */}
                            <div className="col-md-9 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-0"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            {/* Add group modal trigger button */}
                            <div className="col-md-3 text-md-right">
                              <button
                                type="button"
                                className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                data-toggle="modal"
                                data-target="#addTable"
                                onClick={() => {
                                  setnewTableFloor({
                                    ...newTableFloor,
                                    name: "",
                                    code: "",
                                    edit: false,
                                    uploading: false,
                                  });
                                }}
                              >
                                {_t(t("add new"))}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover min-table-height">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Floor Name"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Status"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>

                              <th
                                scope="col"
                                className="table_report_col sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Updated"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!searchedFloor.searched
                              ? [
                                floorList && [
                                  floorList.data.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      floorList.data.map((item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (floorList.current_page - 1) *
                                                  floorList.per_page}
                                            </th>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.name}
                                            </td>

                                            <td className="xsm-text align-middle text-center">
                                            {item.status === "1" ? (
                                              <span
                                                style={{
                                                  color: "Green",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                ON
                                              </span>
                                            ) : (
                                              <span
                                                style={{
                                                  color: "Red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                OFF
                                              </span>
                                            )}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {/* <div className="dropdown">
                                                <button
                                                  className="btn t-bg-clear t-text-dark--light-40"
                                                  type="button"
                                                  data-toggle="dropdown"
                                                >
                                                  <i className="fa fa-ellipsis-h"></i>
                                                </button>
                                                <div className="dropdown-menu">
                                                  <button
                                                    className="dropdown-item sm-text text-capitalize"
                                                    onClick={() => {
                                                      setnewTableFloor({
                                                        ...newTableFloor,
                                                        branch: null,
                                                      });
                                                      handleSetEdit(
                                                        item.slug
                                                      );
                                                    }}
                                                    data-toggle="modal"
                                                    data-target="#addTable"
                                                  >
                                                    <span className="t-mr-8">
                                                      <i className="fa fa-pencil"></i>
                                                    </span>
                                                    {_t(t("Edit"))}
                                                  </button>

                                                  <button
                                                    className="dropdown-item sm-text text-capitalize"
                                                    onClick={() => {
                                                      handleDeleteConfirmation(
                                                        item.slug
                                                      );
                                                    }}
                                                  >
                                                    <span className="t-mr-8">
                                                      <i className="fa fa-trash"></i>
                                                    </span>
                                                    {_t(t("Delete"))}
                                                  </button>
                                                </div>
                                              </div> */}
                                              <button
                                                className="btn btn-primary ml-2 rounded-sm del-btn"
                                                onClick={() => {
                                                  setnewTableFloor({
                                                    ...newTableFloor,
                                                  });
                                                  handleSetEdit(
                                                    item.slug
                                                  );
                                                }}
                                                data-toggle="modal"
                                                data-target="#addTable"                                                    
                                              >                                                    
                                                <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                              </button>
                                              <button
                                              className="btn btn-danger ml-2 rounded-sm del-btn"
                                              onClick={()=>handleDeleteConfirmation(item.slug)}                                                    
                                              >                                                    
                                                <MdDelete className="del-icon" />                                                    
                                              </button>
                                            </td>
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {
                                                item?.updated_at ? (
                                                  <Moment format="LL">
                                                    {item.updated_at}
                                                  </Moment>
                                                ) : ""
                                              }
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ),
                                  ],
                                ]
                              : [
                                  /* searched data, logic === haveData*/
                                  searchedFloor && [
                                    searchedFloor.list.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="6"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      searchedFloor.list.map(
                                        (item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  (floorList.current_page -
                                                    1) *
                                                    floorList.per_page}
                                              </th>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.name}
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                              {item.status === "1" ? (
                                                <span
                                                  style={{
                                                    color: "Green",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  ON
                                                </span>
                                              ) : (
                                                <span
                                                  style={{
                                                    color: "Red",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  OFF
                                                </span>
                                              )}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {/* <div className="dropdown">
                                                  <button
                                                    className="btn t-bg-clear t-text-dark--light-40"
                                                    type="button"
                                                    data-toggle="dropdown"
                                                  >
                                                    <i className="fa fa-ellipsis-h"></i>
                                                  </button>
                                                  <div className="dropdown-menu">
                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        setnewTableFloor({
                                                          ...newTableFloor,
                                                          branch: null,
                                                        });
                                                        handleSetEdit(
                                                          item.slug
                                                        );
                                                      }}
                                                      data-toggle="modal"
                                                      data-target="#addTable"
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                      {_t(t("Edit"))}
                                                    </button>

                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        handleDeleteConfirmation(
                                                          item.slug
                                                        );
                                                      }}
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-trash"></i>
                                                      </span>
                                                      {_t(t("Delete"))}
                                                    </button>
                                                  </div>
                                                </div> */}
                                                {/* <NavLink
                                                className="btn btn-primary ml-2 rounded-sm"
                                                to={`/dashboard/manage/restaurant/manage-party-edit/${item.slug}`}
                                                style={{height:"1.7rem",width:"1.5rem"}}                                                                                                                                            
                                                >
                                                <div className="d-flex align-items-center justify-content-center">
                                                  <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                </div>
                                                </NavLink> */}
                                                <button
                                                className="btn btn-primary ml-2 rounded-sm del-btn"
                                                onClick={() => {
                                                  handleSetEdit(
                                                    item.slug
                                                  );
                                                }}
                                                data-toggle="modal"
                                                data-target="#addTable"                                                    
                                                >                                                    
                                                  <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>                                                    
                                                </button>
                                                <button
                                                className="btn btn-danger ml-2 rounded-sm del-btn"
                                                onClick={()=>handleDeleteConfirmation(item.slug)}                                                    
                                                >                                                    
                                                  <MdDelete className="del-icon" />                                                    
                                                </button>
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {
                                                  item?.updated_at ? (
                                                    <Moment format="LL">
                                                      {item.updated_at}
                                                    </Moment>
                                                  ) : ""
                                                }
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    ),
                                  ],
                                ]}
                          </tbody>
                        </table>
                      </div>
                    </div>                    
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedFloor.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(floorList, setPaginatedFloor)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(floorList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchedFloor({
                                      ...searchedFloor,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchedFloor,
                                    floorForSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default TableFloor;
